const indexItems = [
  {
    id: 1,
    title: '顶流明星恋情实锤合集',
    desc: '收录2024年至今所有被实锤的明星恋情，包含图片证据、时间线和双方回应。',
    count: 37,
    icon: 'ri-heart-line',
    iconBg: 'bg-primary-100 text-primary-600',
  },
  {
    id: 2,
    title: '网红翻车名场面',
    desc: '从带货翻车到人设崩塌，盘点那些曾经风光无限的网红们的"社死"瞬间。',
    count: 52,
    icon: 'ri-emotion-sad-line',
    iconBg: 'bg-accent-100 text-accent-600',
  },
  {
    id: 3,
    title: '综艺争议名场面',
    desc: '热门综艺中的争议片段、导师互怼、选手退赛等经典名场面全记录。',
    count: 28,
    icon: 'ri-tv-line',
    iconBg: 'bg-secondary-100 text-secondary-600',
  },
  {
    id: 4,
    title: '娱乐圈离婚分手全纪录',
    desc: '明星夫妻、情侣分道扬镳的完整档案，从官宣到后续发展的持续追踪。',
    count: 45,
    icon: 'ri-separator',
    iconBg: 'bg-primary-100 text-primary-600',
  },
  {
    id: 5,
    title: '影视圈撕番位大戏',
    desc: '电影电视剧番位之争幕后故事，从官宣海报到发布会站位全程分析。',
    count: 19,
    icon: 'ri-film-line',
    iconBg: 'bg-accent-100 text-accent-600',
  },
  {
    id: 6,
    title: '带货直播事故集锦',
    desc: '明星网红带货翻车现场，从嘴瓢说错话到产品演示失败的高能瞬间。',
    count: 31,
    icon: 'ri-live-line',
    iconBg: 'bg-secondary-100 text-secondary-600',
  },
  {
    id: 7,
    title: '粉丝大战经典案例',
    desc: '饭圈之间的史诗级对决，从控评大战到热搜争夺的完整复盘分析。',
    count: 24,
    icon: 'ri-sword-line',
    iconBg: 'bg-primary-100 text-primary-600',
  },
  {
    id: 8,
    title: '娱乐圈税务风波档案',
    desc: '近年明星网红税务问题全梳理，从被曝到处理结果的完整时间线。',
    count: 16,
    icon: 'ri-bill-line',
    iconBg: 'bg-accent-100 text-accent-600',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 text-accent-600 text-sm font-medium mb-3">
            <i className="ri-folder-2-line"></i>
            专题合集
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            专题爆料合集
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            按主题分类整理的爆料档案，方便你系统性地回顾每一个娱乐圈大事件
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#"
              className="group bg-background-50 rounded-2xl p-6 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${item.iconBg} mb-4 group-hover:scale-110 transition-transform`}>
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading font-bold text-foreground-900 text-base mb-2 group-hover:text-primary-500 transition-colors">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4 flex-1">
                {item.desc}
              </p>
              <div className="flex items-center justify-between text-xs">
                <span className="text-foreground-500 flex items-center gap-1">
                  <i className="ri-file-text-line"></i>
                  {item.count}篇内容
                </span>
                <span className="text-primary-500 flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                  查看 <i className="ri-arrow-right-s-line"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}